import { IForecastGlobalRisk } from '../../interfaces/iforecast-global-risk';
import { ForecastHorizontal } from '../forecast-horizontal';

export class ForecastGlobalRiskBase {
  ForecastGlobalRiskId: number;
  Oil: number | null;
  Gas: number | null;
  Water: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal?: ForecastHorizontal;

  constructor(item?: IForecastGlobalRisk) {
    if (item) {

      this.ForecastGlobalRiskId = item.ForecastGlobalRiskId;
      this.Oil = item.Oil;
      this.Gas = item.Gas;
      this.Water = item.Water;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
    }
  }
}